export default {
  name: "Plus",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M27 16a1 1 0 0 1-1 1h-9v9a1 1 0 0 1-1 1 1 1 0 0 1-1-1v-9H6a1 1 0 0 1-1-1 1 1 0 0 1 1-1h9V6a1 1 0 0 1 1-1 1 1 0 0 1 1 1v9h9a1 1 0 0 1 1 1z",
  },
}
